import { fetchAuthenticardUser } from "./users.service";

export const usersService = { fetchAuthenticardUser };
